import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/core/styles';
import * as Sentry from "@sentry/react";

const useStyles = makeStyles((theme) => ({
  avatarButton: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
      outline: 'none',
    },
    '&:active': {
      backgroundColor: 'transparent',
      outline: 'none',
      boxShadow: 'none',
    },
  },
  avatarName: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    fontSize: '16px',
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

const UserAvatar = ({ name }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    Sentry.captureMessage("Manual logout - /ns", {
      level: "info",
    });
    window.location.href = '/ns?logout=true';
  };

  const open = Boolean(anchorEl);
  const id = open ? 'avatar-menu' : undefined;

  // Always pull from the first and last name if available
  const getInitials = (name) => {
    const words = name.trim().split(' ');

    if (words.length === 1) {
      // If only one name is provided, repeat the first letter twice
      return `${words[0][0]}${words[0][1] || words[0][0]}`.toUpperCase();
    }

    // Otherwise, use the first letter of the first and last name
    const firstNameInitial = words[0][0];
    const lastNameInitial = words[words.length - 1][0]; // Takes from the last word (last name)
    
    return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
  };

  return (
    <div>
      <IconButton
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
        className={classes.avatarButton}
        disableRipple={true}
        disableFocusRipple={true}
      >
        <Avatar className={classes.avatar}>{getInitials(name)}</Avatar>
        <span className={classes.avatarName}>{name}</span>
        <ArrowDropDownIcon />
      </IconButton>
      <Menu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleLogout}>Sign out</MenuItem>
      </Menu>
    </div>
  );
};

export default UserAvatar;



// WEBPACK FOOTER //
// ./src/components/User/UserAvatar.js